<template>
  <div class="info">
    <!-- 头像 -->
    <div class="item_line" id="img">
      <p :style="`background: url(${user.img || '/image/morenHead.png'}) center /cover no-repeat`">
        <input type="file" @change="regImg($event.target.files[0])" :title="pc_lang.Upload_image">
      </p>
    </div>
    <!-- 手机 -->
    <div class="item_line">
      <div>
        <span class="span1">{{pc_lang.Phone_number}}</span>
        <span class="span2">{{signTel}}</span>
        <router-link to="/user/resetTel" tag="span" class="span3">{{pc_lang.Modify}}</router-link>
      </div>
    </div>
    <!-- 邮箱 -->
    <div class="item_line">
      <div>
        <span class="span1">{{pc_lang.Email}}</span>
        <span class="span2">{{signEmail}}</span>
        <router-link to="/user/resetEmail" tag="span" class="span3">{{pc_lang.Modify}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import * as API_USER from '@/api/user'

export default {
  name: 'UserInfo',
  components: {

  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['user']),
    /* 手机加密 */
    signTel() {
      let tel = this.user.mobile
      return !!!tel ? '' : tel.replace(/^(\d{3})\d*(\d{3})$/,'$1****$2')
    },
    /* 邮箱加密 */
    signEmail() {
      let email = this.user.email
      return !!!email ? '' : email.replace(/^(\S{3})\S*(\S{3})$/,'$1****$2')
    }
  },
  async mounted() {

  },
  created() {
    let tempImg = new Image()
    tempImg.src = this.user.img
    tempImg.onerror = ()=> {
      let params = Object.assign({}, this.user)
      params.img = '/image/morenHead.png'
      this.setUser(params)
    }
  },
  methods: {
    ...mapActions({
      freshUser: 'freshUser',
      setUser: 'user'
    }),
    regImg(file){
      if (file) {
        let src = URL.createObjectURL(file)

        let isJPG = file.type == 'image/jpeg' || file.type == 'image/png';
        if (!isJPG) {
          this.$message.error(this.pc_lang.image_supported_with_JPG_PNG_format);
          return false;
        }

        let tempImg = new Image()
        tempImg.src = src
        tempImg.onload = (()=>{
          this.zipImg(file, tempImg).then(res=> {
            this.updateHeadImg(res)
          })
        })
      }
    },
    zipImg(file, tempImg){
      return new Promise((resolve, reject)=> {
        both.imageCompress(file, {
          // size,
          width: tempImg.width < 270 ? tempImg.width : 270,
          // height,
          // fileType,
          qualityArgument: 0.8
        }).then(blob=> {
          resolve(blob)
        }).catch(err=> {
          reject(err)
        })
      })
    },
    updateHeadImg(blob) {
      let params = new FormData
      params.append('headImage', blob)
      API_USER.updateHeadImg(params).then(res=> {
        console.log(res)
        this.freshUser()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.info{
  #img{
    padding: 0 5px 10px;
    p{
      width: 90px;
      height: 90px;
      border-radius: 50%;
      position: relative;
      background-size: 100%;
      input{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
  .item_line{
    >div{
      display: flex;
      align-items: center;
      padding: 0 10px;
      >span{
        &.span1{
          width: 240px;
          font-weight: 600;
        }
        &.span2{
          flex: 1;
          color: #999;
        }
        &.span3{
          color: $blue;
          cursor: pointer;
        }
      }
    }
  }
}
</style>